import React from 'react'
import { Alert } from 'components'
import { NewsletterActionStyles } from './Style'
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { queryClient as qc } from 'keys'
import { editNewsletterFetch, removeNewsletterFetch } from "store/middlewares/newsletter.crud"


const NewChildPopup = (props) => {
    const { type, handleAlert, id } = props
    const queryClient = useQueryClient()

    const { mutateAsync: removeNewsletter } = useMutation({
        mutationFn: removeNewsletterFetch,
        onSuccess: () => {
            queryClient.invalidateQueries([qc.newsletters])
            handleAlert(false)
        }
    })
    const { mutateAsync: editNewsletter } = useMutation({
        mutationFn: editNewsletterFetch,
        onSuccess: () => {
            queryClient.invalidateQueries([qc.newsletters])
            handleAlert(false)
        }
    })

    const actionTypes = {
        "archived": {
            title: "ארכיון",
            content: "האם ברצונך להעביר לארכיון?",
            actionLabel: "לארכיון ",
            action: editNewsletter,
            actionParams: { id: id, status: "ARCHIVED" }
        },
        "trash": {
            title: "מחיקה",
            content: "האם ברצונך למחוק?",
            actionLabel: "מחיקה",
            action: removeNewsletter,
            actionParams: id
        }
    }

    const actionBtns = [
        {
            label: actionTypes[type].actionLabel,
            action: () => actionTypes[type].action(actionTypes[type].actionParams),
            color: "secondary",
        },
        {
            label: "ביטול",
            action: () => handleAlert(false),
            color: "thirdly",
        },
    ]

    return (
        <Alert
            title={actionTypes[type].title}
            footerActions={actionBtns}
            handleAlert={() => handleAlert(false)}
        >
            <NewsletterActionStyles>
                {actionTypes[type].content}
            </NewsletterActionStyles>
        </Alert>
    )
}

export default NewChildPopup